// The vessel position widget (Dashboard): what a stored position may be called. Every position the app shows comes from
// vessel_positions (AIS collect or set by hand), so none is ever called "live". Plain JS: tests/ais.test.mjs.
export const STALE_HOURS = 6

// pos: { ts, source: 'ais' | 'manual', place, set_by } -> { state, label, stale }
//   ais          AIS fix younger than 6 h      green "AIS"
//   last-known   AIS fix older than 6 h        grey  "Last known"
//   manual       set by hand                   blue  "Set by hand" (grey when older than 6 h)
//   none         nothing stored
export function positionState(pos, now = Date.now()) {
  if (!pos || pos.lat == null || pos.lon == null) return { state: 'none', label: 'No position yet', stale: false }
  const t = Date.parse(pos.ts || '')
  const stale = !Number.isFinite(t) || now - t > STALE_HOURS * 3600e3
  if (pos.source === 'manual') return { state: 'manual', label: 'Set by hand', stale }
  return stale ? { state: 'last-known', label: 'Last known', stale: true } : { state: 'ais', label: 'AIS', stale: false }
}

// "Last seen 24 Oct 2026, 09:12 (3 h ago)"
export function lastSeenText(ts, now = Date.now(), locale = 'en-GB') {
  const t = Date.parse(ts || '')
  if (!Number.isFinite(t)) return 'Last seen: unknown'
  const d = new Date(t)
  const when = d.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' }) + ', ' + d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
  return 'Last seen ' + when + ' (' + ageText(now - t) + ')'
}
export function ageText(ms) {
  const m = Math.max(0, Math.floor(ms / 60000))
  if (m < 1) return 'just now'
  if (m < 60) return m + ' min ago'
  const h = Math.round(m / 60)
  if (h < 48) return h + ' h ago'
  return Math.round(h / 24) + ' days ago'
}
// 43.5512, 7.0213 -> "43°33.07'N 7°01.28'E"
export function fmtLatLon(lat, lon) {
  const f = (v, p, n) => { const a = Math.abs(v), d = Math.floor(a), mm = (a - d) * 60; return d + '°' + mm.toFixed(2).padStart(5, '0') + "'" + (v < 0 ? n : p) }
  return f(lat, 'N', 'S') + ' ' + f(lon, 'E', 'W')
}
